import React from 'react';
import { LEGAL_DOCUMENTS, LEGAL_SOURCES } from '../../constants/legal';

const LegalDocumentContent = ({ type = 'privacy', dense = false }) => {
  const legalDocument = LEGAL_DOCUMENTS[type] || LEGAL_DOCUMENTS.privacy;

  return (
    <article className={dense ? 'space-y-5' : 'mx-auto max-w-4xl space-y-7'}>
      <div className={dense ? 'space-y-2' : 'space-y-3'}>
        <div className="flex flex-wrap items-center gap-2">
          <span className="rounded-full bg-[#004AAD]/10 px-3 py-1 text-[0.62rem] font-bold uppercase tracking-[0.14em] text-[#004AAD]">
            Versión {legalDocument.version}
          </span>
          <span className="rounded-full bg-slate-100 px-3 py-1 text-[0.62rem] font-semibold uppercase tracking-[0.14em] text-slate-500">
            Actualizado: {legalDocument.updatedAt}
          </span>
        </div>
        <h1 className={`${dense ? 'text-xl' : 'text-3xl'} font-bold leading-tight text-slate-950`}>
          {legalDocument.title}
        </h1>
        <p className={`${dense ? 'text-sm' : 'text-base'} leading-relaxed text-slate-600`}>
          {legalDocument.intro}
        </p>
      </div>

      <div className="space-y-5">
        {legalDocument.sections.map((section, index) => (
          <section key={section.title} className="border-t border-slate-200 pt-5">
            <div className="flex items-start gap-3">
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-xs font-bold text-slate-500">
                {index + 1}
              </span>
              <div className="min-w-0 space-y-2">
                <h2 className={`${dense ? 'text-sm' : 'text-lg'} font-bold text-slate-900`}>
                  {section.title}
                </h2>
                {section.body.map((paragraph) => (
                  <p key={paragraph} className={`${dense ? 'text-sm' : 'text-[0.95rem]'} leading-relaxed text-slate-600`}>
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
          </section>
        ))}
      </div>

      <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
        <p className="text-[0.65rem] font-bold uppercase tracking-[0.14em] text-slate-400">
          Referencias normativas
        </p>
        <div className="mt-3 flex flex-col gap-2">
          {LEGAL_SOURCES.map((source) => (
            <a
              key={source.url}
              href={source.url}
              target="_blank"
              rel="noreferrer"
              className="text-sm font-semibold text-[#004AAD] underline-offset-4 hover:underline"
            >
              {source.label}
            </a>
          ))}
        </div>
      </div>
    </article>
  );
};

export default LegalDocumentContent;
